import React from "react";
import profilePlc from "../../assets/profile_image_placeholder.png";

//Provides the user image and display name
export const DashboardHeader = (params) => {
    return (
        <img src={profilePlc} alt={params.firstName} className={params.profile_style} />
    )
}